import { httpRequest } from "@services/http";
import type { LaunchNetworkConfig } from "@models/launchNetwork.model";
import { LaunchNetworkConfigSerializer } from "@models/serializers/launchNetworkSerializer";

export class CommandToggleLaunchNetwork {
  async run(launchId: number, network: string, isEnabled: boolean): Promise<LaunchNetworkConfig> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/networks/${network.toLowerCase()}/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify({ is_enabled: isEnabled }),
    });

    const serializer = new LaunchNetworkConfigSerializer();
    return serializer.deserialize(response);
  }
}